<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <Breadcrumbs
        headline="Đối soát đơn hàng nhập"
        :link="[{ text: 'Đối soát đơn hàng nhập', href: '/verify-import' }]"
      />
    </div>
    <FilterVerifyImport />
    <v-card outlined class="mx-4 mb-6 elevation-0">
      <TableVerifyImport />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FilterVerifyImport from '../../modules/verifyImport/FilterVerifyImport.vue'
import TableVerifyImport from '../../modules/verifyImport/TableVerifyImport.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Breadcrumbs,
    FilterVerifyImport,
    TableVerifyImport
  },
  async created() {
    await this.fetchVerifyOrders()
    await this.countVerifyOrders()
    await this.getStats()
  },
  methods: {
    ...mapActions({
      fetchVerifyOrders: 'verifyImport/fetchItems',
      countVerifyOrders: 'verifyImport/countItems',
      getStats: 'verifyImport/getStat'
    })
  }
}
</script>

<style lang="scss" scoped></style>
